import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the actions an assistant or a token prepared for the signed-in user (ADR-265): those still open,
// every one, and one by its id for the page of its link.

const actions = api.identity.me["prepared-actions"];

export type PreparedAction = InferResponseType<(typeof actions)[":actionId"]["$get"], 200>;

const keys = { all: ["prepared-actions"] as const };

export const preparedActionQueries = {
  ...keys,

  list: (state: "open" | "all") =>
    queryOptions({
      queryKey: [...keys.all, "list", state],
      queryFn: ({ signal }) => unwrap(actions.$get({ query: { state, limit: "100" } }, { init: { signal } })),
    }),

  detail: (actionId: string) =>
    queryOptions({
      queryKey: [...keys.all, "detail", actionId],
      queryFn: ({ signal }) => unwrap(actions[":actionId"].$get({ param: { actionId } }, { init: { signal } })),
    }),
};
